import { useNavigate } from 'react-router-dom'
import { StaticAnnouncement, StaticAnnouncementAction } from '@/components/static-announcement'
import { Icons } from '@/theme/Images'
import { ROUTE_PAYMENTS, ROUTE_PAYMENTS_MAKE_PAYMENT } from '../routes/paths'
import { useAuth } from '@/contexts/auth.context'

const FinancialAccountDelinquentSuspendedBanner = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  return (
    user?.isFinancialAccountDelinquentAndSuspended?.() && (
      <div className={'md:mx-[10%] md:mt-[2%] bg-bgGray md:m-0 mx-6 mt-6'}>
        <div className="flex flex-col md:gap-8 gap-5">
          <StaticAnnouncement
            startIcon={Icons.grayNotificationIcon}
            text={
              <>
                Your account has been suspended due to a past-due payment. Your card cannot be used until a payment is
                made. Please pay now or reach out to&nbsp;
                <a className="font-semibold text-brand-500" href="mailto:help@fasten.cc">
                  help@fasten.cc
                </a>
                &nbsp;for support.
              </>
            }
            action={
              <StaticAnnouncementAction
                text="Make payment"
                handleClick={() => navigate(`/${ROUTE_PAYMENTS}${ROUTE_PAYMENTS_MAKE_PAYMENT}`)}
              />
            }
          />
        </div>
      </div>
    )
  )
}

export default FinancialAccountDelinquentSuspendedBanner
